<template>
  <div class="projects">
    <h1>My Work</h1>
    <h2>Check out some of my projects...</h2>
    <div class="grid">
      <div class="item">
        <a href="https://dahorder.my">
          <img src="../assets/projects/dahorder.png" alt="Project" />
        </a>
        <!-- <a href="#" class="btn-light"> <i class="fas fa-eye"></i> Project </a> -->
        <a href="https://github.com/sterling000/dahorder" class="btn-dark">
          <i class="fab fa-github"></i> Github
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.projects {
  display: grid;

  margin: auto;
  max-width: 800px;
  grid-gap: 0.7em;
  img {
    width: 100%;
    border: 3px #000 solid;
    :hover {
      opacity: 0.5;
      border-color: #aaa;
      transition: all 0.5s ease-out;
    }
  }
  .btn,
  .btn-dark,
  .btn-light {
    display: block;
    padding: 0.5rem 1rem;
    border: 0;
    margin-bottom: 0.3rem;
  }
  .btn:hover,
  .btn-dark:hover,
  .btn-light:hover {
    background: #eece1a;
    color: #000;
  }

  .btn-dark {
    background: black;
    color: #fff;
  }

  .btn-light {
    background: #c4c4c4;
    color: #333;
  }
}
</style>
